module.exports = __webpack_public_path__ + "img/coach-example.6cad9f59.jpg";